<template>
    <div class="page-content">
        <transition name="fade-transform" mode="out-in">
            <!-- <keep-alive> -->
            <router-view :key="$route.path" />
            <!-- </keep-alive> -->
        </transition>
    </div>
</template>

<script>
export default {
    name: "layout",
    data() {
        return {};
    },
    watch: {},
};
</script>



<style scoped lang="less">
</style>
